module.exports = __webpack_public_path__ + "img/kitchenware_icon.73fec845.png";